<app-nav [admin]="true"></app-nav>
<router-outlet></router-outlet>
